import { render, staticRenderFns } from "./functionDefine.vue?vue&type=template&id=6714ab10&scoped=true"
import script from "./functionDefine.vue?vue&type=script&lang=js"
export * from "./functionDefine.vue?vue&type=script&lang=js"
import style0 from "./functionDefine.vue?vue&type=style&index=0&id=6714ab10&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6714ab10",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6714ab10')) {
      api.createRecord('6714ab10', component.options)
    } else {
      api.reload('6714ab10', component.options)
    }
    module.hot.accept("./functionDefine.vue?vue&type=template&id=6714ab10&scoped=true", function () {
      api.rerender('6714ab10', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/product/product-details/functionDefine.vue"
export default component.exports